import { forwardRef } from 'react';
import ButtonInternal from './button-internal';
const Button = forwardRef(ButtonInternal);
export default Button;
